import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { AmplifyService } from 'aws-amplify-angular';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../../view.service';
import { STORAGE_CONFIG } from 'src/app/configs';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { MsgLoadingService } from 'src/app/shared/components/msgLoading/msgLoading.service';

declare var $:any;

@Component({
  selector: 'gallery-share',
  templateUrl: './gallery-share.component.html',
  styleUrls: ['./gallery-share.component.scss']
})
export class GalleryShareComponent extends AdUtils implements OnInit {

  @Input() info: any;
  @Input() opened: any = false;
  title = '';
  defaultTitle = '';
  list: any = {};
  selected: any = [];
  total = 0;
  path: any = '';
  shareStarted = false;
  shareDownloaded = 0;
  shareTotal = 0;
  shareFiles: any = [];
  zip: any = null;
  zipName: any = '';
  lastGalleryDownload = null;
  lastGalleryCount = 0;

  downloadComplete = false;
  downloadTimeout = null;

  buttons = [];

  fileType = 'jpg';
  fileSize = 'medium';
  totalSize = '';

  constructor(
    private as: AmplifyService,
    srs: AdSearchService,
    gs: GeneralService,
    vs: ViewService,
    protected mls: MsgLoadingService,
    protected snack: SnackBarService,
    protected cdr : ChangeDetectorRef
  ) {
    super(srs, gs, vs);

    this.as.auth().currentCredentials().then(result => {
      if (result['data'] != undefined)
        this.path = result['data'].IdentityId;
    });
    this.as.storage().configure(STORAGE_CONFIG);
  }

  eventCallback(e) { }

  setDefault() {
  }

  onlyImages(item){
    return item?.originalData?.mime? item.originalData.mime.indexOf('video') == -1  : item.mime.indexOf('video') == -1;
  }

  ngOnInit() {
    this.list = [
      {
        title: 'Geral',
        type: 'grid',
        items: this.info.imagesGeneral.map(item => { item.galleryName = 'Geral'; return item; })
      }
      , {
        title: 'Unidades',
        type: 'grid',
        items: this.info.imagesUnits.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Unidades'; return item; })
      }
      , {
        title: 'Área de lazer',
        type: 'grid',
        items: this.info.imagesRecreationArea.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Área de lazer'; return item; })
      }
      , {
        title: 'Plantas',
        type: 'grid',
        items: this.info.imagesPlants.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Plantas'; return item; })
      }
      , {
        title: 'Showroom',
        type: 'grid',
        items: this.info.imagesShowroom.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Showroom'; return item; })
      }
      , {
        title: 'Entrega',
        type: 'grid',
        items: this.info.imagesDelivery.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Entrega'; return item; })
      }
      , {
        title: 'Publicação rede social',
        type: 'grid',
        items: this.info.imagesSocialArea.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Publicação rede social'; return item; })
      }
      ,{
        title : 'Conteúdo para corretor',
        type : 'grid',
        items : this.info.realtorLearning.map(item => { item.galleryName = 'Conteúdo para corretor'; return item; })
      }
      ,{
        title : 'Vídeos',
        type : 'grid',
        items : this.info.videos.map(item => { item.galleryName = 'Vídeos'; return item; })
      }
      ,{
        title : 'Acompanhamento',
        type : 'grid',
        items : this.info.progress.map(item => { item.galleryName = 'Acompanhamento'; return item; })
      }
      , {
        title: 'Logo',
        type: 'grid',
        items: this.info.imagesLogo.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Logo'; return item; })
      }
      , {
        title: 'Documentos',
        type: 'list',
        items: this.info.documents.filter(item => this.onlyImages(item)).map(item => { item.galleryName = 'Documentos'; return item; })
      }
    ];

    this.info.galleryShare = [];

    this.list.map(item => {
      this.total += item?.items?.length;
      if(item.type == 'grid')
        this.info.galleryShare = this.info.galleryShare.concat(item.items);
    });

  }

  setSelect(block) {
    let selected = this.hasSelect(block);
    if (block == 'all') {
      this.selected = [];
      if (!selected)
        this.list.map(item => this.selected = this.selected.concat(item.items));
    } else if (block instanceof Array) {
      this.selected = selected ? this.selected.filter(item => !block.filter(sel => item == sel).length) : this.selected.concat(block);

    } else {
      if (selected)
        this.selected = this.selected.filter(item => item != block);
      else
        this.selected.push(block);
    }

    this.title = !!this.selected.length ? this.selected.length : this.defaultTitle;

    this.buttons = this.getImageFormatList(true);

    setTimeout(()=>{
      $('[data-toggle="tooltip"]').tooltip({
        trigger : 'hover'
      });
    },200);

    this.setTotalSize();

  }

  hasSelect(block) {
    if (block == 'all')
      return this.selected.length >= this.total;
    else if (block instanceof Array)
      return this.selected.filter(item => !!block.filter(sel => item == sel).length).length >= block.length;
    else
      return !!this.selected.filter(item => item == block).length;
  }

  async getImage(url, fileName) {
    // on the first then you will return blob from response
    return await fetch(url).then(r => r.blob())
      .then((blob) => { // on the second, you just create a file from that blob, getting the type and name that intend to inform

        return new File([blob], fileName);
      });
  }


  zipAddFile(originalFile, fileAdd, fileAddContent, withError = false) {

    let error = fileAddContent?.name == '' || withError;

    if (!error)
      this.zip.file(fileAdd, fileAddContent);

    this.shareFiles = this.shareFiles.filter(item => item.href.indexOf(originalFile) == -1);
    this.shareDownloaded = Object.keys(this.zip.files).length;

    if (!error && !this.shareFiles.length && this.shareDownloaded > 0) {
      this.mls.setMessage('download', { message: 'Gerando arquivo zip' });


      this.zip
        .generateAsync(
          {
            type: "blob",
            compression: "DEFLATE"
          })
        .then((content) => {
          // see FileSaver.js
          this.mls.setMessage('download', { message: 'Pronto! Download concluído' });
          this.snack.close('download', 1000);          
          saveAs(content, this.zipName + ".zip");
          this.downloadComplete = true;
          this.downloadTimeout = setTimeout(() => {
            this.downloadComplete = false;
          }, 3000);
          this.shareStarted = false;
        });
    } else {
      this.syncZip(true)
    }
  }

  share(event, zip = false) {

    let files = this.selected;

    this.downloadComplete = false;
    if(this.downloadTimeout)
      clearTimeout(this.downloadTimeout);

    if(!!this.buttons?.length){
      let selected = this.buttons.filter(item => item.fileSize == this.fileSize && item.fileType == this.fileType)[0];
      files = selected.files;
      this.totalSize = selected.size;
    }

    if (this.shareStarted)
      return;

    this.shareStarted = true;
    this.shareDownloaded = 0;
    this.shareFiles = files;
    this.shareTotal = files.length;

    this.snack.openComponent('download', { message: 'Iniciando download, aguarde...' });

    this.zip = new JSZip.default();
    this.zipName = this.info.title;

    this.syncZip(zip);
  }

  async syncZip(zip = false) {
    if (typeof this.shareFiles[0] == 'undefined') {
      this.mls.setMessage('download', { message: 'Ocorreu um erro' });
      this.snack.close('download', 1000);
      this.shareStarted = false;
      return;
    }
    let file = this.shareFiles[0];

    let parts = file.href.split('/');
    let fileName = parts[parts.length - 1];
    let fileNameExport = file?.name || fileName;

    if (this.lastGalleryDownload != file.galleryName) {
      this.lastGalleryDownload = file.galleryName;
      this.lastGalleryCount = 1;
    }

    if(!!this.shareTotal)
      this.mls.setMessage('download', 
        zip? { message: 'Compactando arquivos, ' + (this.shareFiles.length > 1 ? 'faltam ' + this.shareFiles.length : 'falta 1') } : 
            { message: 'Baixando arquivos, ' + (this.shareFiles.length > 1 ? 'faltam ' + this.shareFiles.length : 'falta 1') }
      );

    let fileNameZip = this.lastGalleryDownload + ' - ' + this.lastGalleryCount.toString().padStart(3, "0") + ' - ' + fileNameExport;
    this.as.storage().get(fileName, {
      level: 'protected',
      identityId: parts[parts.length - 2] // the identityId of that user
    })
      .then(async result => {

        await this.getImage(result, fileName).then(async filetoRead => {

          if(this.shareTotal == 1 || !zip){
            await saveAs(filetoRead, this.zipName+' - '+fileNameZip);
            this.mls.setMessage('download', { message: 'Download concluído' });
            this.snack.close('download', 1000);

           
           this.shareFiles = this.shareFiles.filter(item => item.href.indexOf(file.href) == -1);
           this.shareDownloaded = Object.keys(this.zip.files).length;
           
           console.log(fileNameZip, this.shareFiles, this.shareDownloaded);

            if(!!this.shareFiles?.length)
              this.syncZip(zip);
            else {
              this.downloadComplete = true;
              this.downloadTimeout = setTimeout(() => {
                this.downloadComplete = false;
              }, 3000);
              this.shareStarted = false;
              this.shareFiles = [];
            }
          } else {
            this.zipAddFile(fileName, fileNameZip, filetoRead);
            this.lastGalleryCount++;
          }

        })
      })
      .catch(err => {
        this.zipAddFile(fileName, fileNameZip, null, true);
        this.lastGalleryCount++;
      });

  }




  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'kb', 'mb', 'gb', 'rb', 'pb', 'eb', 'zb', 'yb'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getImageFormatList(acceptWebp) {


    let sizes: any = {};
    let extras = [];
    let extraSize = 0;
    let videos = [];

    this.selected.map(item => {
      if(item?.mime.indexOf('video') > -1){
        let last = item.originalData.variations[item.originalData.variations?.length-1];
        item.href = last.href;
        extraSize+= last.size;

        videos.push(item);

      } else if (!item.originalData?.variations){
        extras.push(item);
        extraSize += typeof item?.variations[0]?.size !== 'undefined'? item?.variations[0]?.size : 0;
      } else
        item.originalData?.variations?.map(image => {
          if (image?.resizeType != 'thumb') {
            image.galleryName = item.galleryName;
            if (!sizes[image?.resizeType])
              sizes[image?.resizeType] = { webp: { size: 0, files: [] }, jpg: { size: 0, files: [] } };

            if (!sizes[image?.resizeType][image?.mime == 'image/webp' ? 'webp' : 'jpg'].files.filter(item => item.href == image.href).length) {
              sizes[image?.resizeType][image?.mime == 'image/webp' ? 'webp' : 'jpg'].size += image.size;
              sizes[image?.resizeType][image?.mime == 'image/webp' ? 'webp' : 'jpg'].files.push(image);
            }
          }

        });
    });

    let buttons = [];
    Object.entries(sizes).forEach(([key, value]) => {
      let webpsize = this.formatBytes(value['webp'].size + extraSize);
      let jpgsize = this.formatBytes(value['jpg'].size + extraSize);
      let title = '';
      let subtitle = '';

      switch (key) {
        case 'medium':
          title = 'Média';
          subtitle = 'Ideal para WhatsApp';
          break;
        case 'large':
          title = 'Alta';
          subtitle = 'Ideal para Instagram, site';
          break;
        case 'extralarge':
          title = 'Altíssima';
          subtitle = 'Ideal para impressão';
          break;
      }

      if (acceptWebp)
        buttons.push({ type: 'button', class: 'image', dismiss: true, action: 'webp_' + key, title: title, subtitle: subtitle, files: [].concat(value['webp'].files).concat(extras).concat(videos), fileType: 'webp', fileSize:key, size: webpsize, endTitleClass: 'text-right font-xs m-0', icon: 'file-image' })

      buttons.push({ type: 'button', class: 'image', dismiss: true, action: 'jpg_' + key, title: title, subtitle: subtitle, files: [].concat(value['jpg'].files).concat(extras).concat(videos), fileType: 'jpg', fileSize:key, size: jpgsize, endTitleClass: 'text-right font-xs m-0', icon: 'file-image' })
    });

    return buttons;
  }

  setFileType(type) {
    this.fileType = type;
    this.setTotalSize();
  }

  setFileSize(size) {
    this.fileSize = size;
    this.setTotalSize();
  }

  setTotalSize() {
    let selected = this.buttons.filter(item => item.fileSize == this.fileSize && item.fileType == this.fileType)[0];
    this.totalSize = selected?.size || '';
    if(this.totalSize == '' && !!this.selected?.length){
      let totalSize = 0;
      this.selected.map(item => {
        totalSize += typeof item?.variations !== 'undefined' && typeof item?.variations[0] !== 'undefined' && item?.variations[0]?.size? item?.variations[0]?.size : 0;
      });
      this.totalSize = totalSize == 0? '' : this.formatBytes(totalSize);
    }

  }

  openExternal(event, file){
    event?.stopPropagation();
    var  element = document.createElement('a') as HTMLElement;
    element.setAttribute('href', file.href);
    element.setAttribute('target', '_blank');
    element.setAttribute('style', 'display:none;');
    element.click();
  }

  zoom(event, file, gallery){
    event?.stopPropagation();
    this.setGallery(file,'galleryShare', false);
  }

}